import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { SVGEditorComponent } from "./svg-editor.component";
import { parse } from "css";
import { FormsModule } from "@angular/forms";

@Component({
  imports: [CommonModule, SVGEditorComponent, FormsModule],
  standalone: true,
  templateUrl: "./svg-editor-panel.component.html",
  styles: [],
})
export class SVGEditorPanelComponent implements AfterViewInit {
  @ViewChild(SVGEditorComponent) SVGEditorComponent: SVGEditorComponent;
  properties: any;
  brandColors: any = [];

  ngAfterViewInit(): void {
    window.addEventListener("message", (event) => {
      switch (event.data.type) {
        case "set-branding":
          this.brandColors = [];
          const parsedCss = parse(event.data.properties || "");
          parsedCss.stylesheet.rules.forEach((rule: any) => {
            if (
              rule.selectors?.includes(".nis-catalog") ||
              rule.selectors?.includes("body")
            ) {
              rule.declarations.forEach((declaration: any) => {
                if (
                  declaration.property.startsWith("--") &&
                  declaration.property.includes("color")
                ) {
                  this.brandColors.push({
                    key: `var(${declaration.property})`,
                    value: declaration.value,
                  });
                }
              });
            }
          });
          break;
        case "set-properties":
          this.properties = event.data.properties || {};
          break;
      }
    });

    window.parent.postMessage(
      {
        type: "svg-editor-panel-ready",
      },
      "*"
    );
  }

  onSvgChange(svg: Record<string, string>) {
    this.properties = { ...this.properties, ...svg };
    window.parent.postMessage(
      {
        type: "update-properties",
        properties: this.properties,
      },
      "*"
    );
  }
}
